import { FormField } from 'ui/formField';
import noop from 'lodash/noop';
import { useMemo } from 'react';
import { StyledFormLabel, StyledRadioList } from './ModifySubscriptionEditor.styles';
import {
  SUBSCRIPTION_ACTION_OPTIONS,
  SubscriptionAction,
} from './ModifySubscriptionEditor.constants';

export interface ActionPickerProps {
  /** Does this have an error */
  hasError?: boolean;
  /** Error text to show */
  errorText?: string;
  /** Callback when the selection changes */
  onSelect?: (value: boolean) => void;
  /** Is the field disabled? */
  isDisabled?: boolean;
  /** Current value */
  value?: boolean;
}

const ActionPicker = ({
  hasError,
  errorText = '',
  onSelect = noop,
  isDisabled = false,
  value,
}: ActionPickerProps) => {
  const options = useMemo(
    () => SUBSCRIPTION_ACTION_OPTIONS.map((opt) => ({ ...opt, isDisabled })),
    [isDisabled],
  );
  // Radio doesn't work with bools for some reason
  const parsedValue = useMemo(
    () => (value ? SubscriptionAction.Subscribe : SubscriptionAction.Unsubscribe),
    [value],
  );

  return (
    <FormField hasError={hasError} errorText={errorText}>
      <StyledFormLabel>Action</StyledFormLabel>
      <StyledRadioList
        name="set-sub-action"
        onSelect={(selection) => onSelect(selection === SubscriptionAction.Subscribe)}
        options={options}
        value={parsedValue}
      />
    </FormField>
  );
};

export default ActionPicker;
